import { Space } from 'antd';
import React from 'react';

import DetailPageHeader from '../components/detail-page-header';
import { SPACING } from '../theme/tokens';

function OfferContainer(): React.ReactElement {
  return (
    <Space size={SPACING.lg} align="start" orientation="vertical">
      <DetailPageHeader title="Offer" />
    </Space>
  );
}

export default OfferContainer;
